import { lazyImport } from "../utils/lazyImport";
import LiveEnd from "../modules/live-end";
import LiveEndAttendee from "../modules/live-end/index_attendee";
import { screens } from "../constants";
import AuthRoutes from "../modules/auth";
import LiveMain from "../modules/live-main";
import Registration from "../modules/auth/Registration";
import Login from "../modules/auth/Login";
import MediaDeviceTest from "../modules/agora-live/components/avDetector";

// const { AuthRoutes } = lazyImport(() => import('@/features/auth'), 'AuthRoutes');
// lazyImport(() => import('../modules/live-end'), LiveEnd);

export const publicRoutes = [
  {
    // path: '/auth/*',
    // element: <AuthRoutes />,

    path :"/endLive",
    element:<LiveEnd/>,
    
  },
  {
    path :"/endLiveAttendee",
    element:<LiveEndAttendee/>,
    
  },
  // {
  //   path: "/",
  //   element: <LiveMain />,
  // },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/auth/*",
    element: <AuthRoutes />,
  },
  {
    path: "/:id",
    element: <Registration />,
  },
  {
    path: "/:id/login",
    element: <Registration />,
    
  },
  {
    path: "/:id/login",
    element: <Registration />,
  },
  {
    path: "/stream/:id",
    element: <LiveMain />,
  }
  // {
  //   path: "/live-main",
  //   element: <LiveMain />,
  // },
];
